import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import userServices from "../../user/userAction";

const initialState = {
  user: null,
  loading: false,
  error: false,
  success: false,
  message: null,
};

export const userDetailsAction = createAsyncThunk("userDetailsAction", () => {
  return userServices.getUserDetails();
});

//CREATE THE SLICE

export const userDetailsSlice = createSlice({
  name: "userDetails",
  initialState,
  reducers: {
    //non asynchronous reducers goes here
    reset: (state) => {
      state.loading = false;
      state.error = false;
      state.success = false;
      state.message = "";
      state.user = {};
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(userDetailsAction.pending, (state) => {
        state.loading = true;
      })
      .addCase(userDetailsAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.user = action.payload?.data?.user;
      })
      .addCase(userDetailsAction.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.message = action.payload;
        state.user = null;
      });
  },
});

export const { reset } = userDetailsSlice.actions;

export default userDetailsSlice.reducer;
